import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-lg text-white"></i>
                </div>
                <span className="font-heading text-xl text-white whitespace-nowrap">
                  极速影院
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                极速影院致力于为广大观众提供高清流畅的综艺节目在线观看体验，涵盖音乐、户外、脱口秀等多种类型，让您随时随地享受精彩娱乐内容。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-white mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/category/music" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    音乐综艺
                  </Link>
                </li>
                <li>
                  <Link to="/category/outdoor" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    户外真人秀
                  </Link>
                </li>
                <li>
                  <Link to="/category/talkshow" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    脱口秀
                  </Link>
                </li>
                <li>
                  <Link to="/category/competition" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    竞技挑战
                  </Link>
                </li>
                <li>
                  <Link to="/category/food" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    美食综艺
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-white mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <a href="#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    联系我们
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-white mb-4">关注我们</h4>
              <p className="text-sm text-background-400 mb-4">
                获取最新综艺资讯和观看指南
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-background-300"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-background-300"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-background-300"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="Bilibili">
                  <i className="ri-bilibili-line text-background-300"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 极速影院 JisuCinema.com 版权所有
            </p>
            <p className="text-xs text-background-600">
              本站所有内容仅供娱乐参考，不存储任何视频文件
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}